import React, {Component} from 'react';
import {Button} from 'reactstrap';
import {FaIcon} from "../FaIcon";
import {SyncConfigurationModal} from "./SyncConfigurationModal";
import { withTranslation } from 'react-i18next';


class CreateNewConfigurationModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };

        this.toggle = this.toggle.bind(this);
        this.afterSubmit = this.afterSubmit.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    afterSubmit() {
        this.toggle();
        this.props.onCreateNewSyncConfigurations();
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <Button className="btn -alt" onClick={this.toggle}>
                    <FaIcon iconName="table"/>
                    {t('create_new_configuration_modal.new_sync')}
                </Button>
                <SyncConfigurationModal 
                    isOpen={this.state.modal} 
                    toggle={this.toggle} 
                    onSave={this.afterSubmit} 
                />
            </div>
        );
    }
}

export const CreateNewConfigurationModal = withTranslation()(CreateNewConfigurationModalClass);
export default CreateNewConfigurationModal;

